import { PurchaseOrderDto } from './purchaseOrder.dto';
import { BaseDto } from './base.dto';

export class PurchaseOrderEmailMessageIdDto extends BaseDto {
  purchaseOrderId: number;
  purchaseOrderEmailMessageId: string;
  emailTypeId: number;
  emailAttachmentURL?: string;

  purchaseOrder?: PurchaseOrderDto;
}
